import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CUSTOMER_STATUS_META = {
    active: { color: 'success', labelEn: 'Active', labelAr: 'نشط' },
    banned: { color: 'error',   labelEn: 'Banned', labelAr: 'محظور' },
};

const CustomerStatusBadge = ({ status, sx }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const meta = CUSTOMER_STATUS_META[status] || {
        color: 'default',
        labelEn: status || '-',
        labelAr: status || '-',
    };

    return (
        <Chip
            label={isArabic ? meta.labelAr : meta.labelEn}
            size="small"
            color={meta.color}
            variant="tonal"
            sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '70px', ...sx }}
        />
    );
};

export default CustomerStatusBadge;
